import { render } from "./SingleButton.vue?vue&type=template&id=2b717b9e&scoped=true"
import script from "./SingleButton.vue?vue&type=script&lang=js"
export * from "./SingleButton.vue?vue&type=script&lang=js"

import "./SingleButton.vue?vue&type=style&index=0&id=2b717b9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b717b9e"

export default script